export default {"src":"/_next/static/media/image_detail_content.234a9115.svg","height":220,"width":344,"blurWidth":0,"blurHeight":0};